import styled from 'styled-components';
import { RawButton } from '../../../Button/Button.styles';

export const StyledFmToggleButton = styled(RawButton)(({ theme }) => ({
  fontFamily: theme.fontFamily,
  fontWeight: theme.fontWeights[500],
  fontSize: theme.fontSizes.small,
  lineHeight: theme.lineHeights.small,
  borderRadius: theme.radii.full,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: `${theme.space[8]}px ${theme.space[16]}px`,
  color: theme.colors.black,
  background: theme.colors.neutral['100'],
  transition: 'background ease-in-out 120ms',

  '&&:not(.disabled)[aria-pressed=true], &&:not(.disabled):active': {
    color: theme.colors.white,
    background: theme.colors.primary['500'],

    '&:not(.disabled):focus': {
      color: theme.colors.white,
      background: theme.colors.primary['500'],
    },

    '&&:hover': {
      color: theme.colors.white,
      background: theme.colors.primary['500'],
    },
  },

  '&:not(.disabled):focus': {
    color: theme.colors.black,
    background: theme.colors.neutral['100'],
  },

  '&&:hover': {
    color: theme.colors.black,
    background: theme.colors.neutral['200'],
  },

  '&[data-focus-visible-added]:not(.disabled):focus': {
    outline: 'none',
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`,
    zIndex: 1,
  },
}));
